<template>
	<div>
		<h1 class="border-b-2 border-slate-200 pb-1 flex items-end space-x-2 justify-between">
			<p class="text-xl font-bold">Won Auctions</p>
		</h1>

		<div class="space-y-8 mt-4">
			<p v-if="auctions.length == 0"
				class="text-slate-500 text-lg text-center">
				You haven't won any items yet
			</p>
			<won-auction-listing
				v-else
				v-for="auction in auctions"
				:key="`auction-${auction.id}`"
				:auction="auction"
				class="flex-1"
			/>
		</div>

		<claim-lot-modal
			v-if="state.claimAuction"
			@close="state.claimAuction = null"
			:auction="state.claimAuction"
			:key="`auction-claim-${state.claimAuction? state.claimAuction.id : 'null'}`"
		/>
	</div>
</template>
<script lang="ts">
import { computed, defineComponent, PropType, onMounted, reactive, ref } from "vue";
import AuctionList from "@/pages/Account/AuctionList.vue";
import WonAuctionListing from "@/components/WonAuctionListing.vue";
import ClaimLotModal from '@/components/ClaimLotModal.vue'
import { useAuctionStore } from "@/stores/AuctionStore";
import { useProfileStore } from "@/stores/ProfileStore";
import { useAuthStore } from "@/stores/AuthStore";
import { useAppStore } from "@/stores/AppStore";
import { Auction } from "@/types/Auction";
import { DateTime } from "ts-luxon";
import Currency from "@/types/Currency";

export default defineComponent({
	components: { AuctionList, WonAuctionListing, ClaimLotModal },
	setup(props) {
		const auctionStore = useAuctionStore()
		const profileStore = useProfileStore()
		const authStore = useAuthStore()
		const appStore = useAppStore()
		const now = ref(DateTime.now())
		let timerInterval;

		const state = reactive({
			claimAuction: null as Auction | null,
		})

		onMounted(async() => {
			const t = await authStore.authToken()
			profileStore.loadAccount(
				t
			);

			timerInterval = setInterval(() => {
				now.value = DateTime.now()
			}, 1000)
		})

		const auctions = computed(() => {
			return profileStore.wonAuctions.sort(
				(left, right) => {
					if (left.claimed_at && right.claimed_at) {
						return -1 * (left.end_at - right.end_at)
					}

					if (left.claimed_at) return -1
					if (right.claimed_at) return 1
				}
			)
		});

		function onClaim(auction) {
			state.claimAuction = auction
		}

		const canClaimAuctions = computed(() => {
			return auctions.value.reduce((all, auction) => {
				all[ auction.id ] = auction.claimed_at == null
					&& now.value > auction.auction_group.end_at.plus( auction.extended_bidding_seconds )
				return all;
			}, {})
		})

		return {
			profileStore,
			Currency,
			state,
			auctions,
			appStore,
			onClaim,
			now,
			canClaimAuctions,
		}
	}
})
</script>
